import styled from "styled-components";
import {colors, devices} from "../../utils/styled/_variables.styled";

const InfiosViewSwitch = styled.div`
  display: flex;
  justify-content: center;
  .viewswitch{
    max-width: ${props => props.fullWidth === 'fullwidth' ? 'none' : '870px'};
    width: 100%;
    @media ${devices.tabletLarge} {
      max-width: 100%;
    }
  }

  .viewswitch__buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 32px 0 0;

    &__switches{
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .top-pagination {
      margin: 0;

      ul {
        height: auto;
      }
    }
  }

  .viewswitch__button {
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.gray1};

    padding: 0;
    border: none;
    transition: all 0.3s ease-in-out;

    border-radius: 50%;

		svg {
			path {
				fill: ${colors.infiosGray}
			}
		}

    .viewswitch__ico {
      &--active{
        fill: ${colors.infiosGray}
      }
    }

    :hover {
      background-color: ${colors.limeGreen};

      .viewswitch__ico {
        &--sort{
          > path {
            fill: ${colors.infiosGray};
          }
        }
      }

      .viewswitch__icon_list {
        > path {
          fill: ${colors.infiosGray};
        }
        > rect {
          fill: ${colors.infiosGray};
        }
      }

      .viewswitch__icon_grid {
        > rect {
          fill: ${colors.infiosGray};
        }
      }
    }
  }

  .viewswitch__content_list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 80px;

    @media ${devices.tabletLarge} {
      margin-top: 64px;
    }

    @media ${devices.mobile} {
      margin-top: 56px;
    }

    > section section {
      max-width: 757px;
    }
  }

  .viewswitch__content_grid {
    /* display: flex;
    flex-direction: row;
    flex-flow: wrap; */
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    margin: 80px 0;
    row-gap: 80px;
    column-gap: 32px;
    &__anchor{
      height: 592px;
      max-width: 418px;
    }

    @media ${devices.tabletLarge} {
      grid-template-columns: 1fr 1fr;
      row-gap: 64px;
      &__anchor{
        height: 469px;
        max-width: unset;
        width: 100%;
      }
    }

    @media ${devices.mobile} {
      grid-template-columns: 1fr;
      row-gap: 56px;
      &__anchor{
        height: 462px;
      }
    }

    > div {
      width: auto;
      margin: 0;
    }
  }
`;
export { InfiosViewSwitch };
